import { EmployeeCertificateOrMissingCertificate } from '../index'

interface Props {
  certificate: EmployeeCertificateOrMissingCertificate
}

export const Position = ({ certificate }: Props) => {
  return <>{certificate.positionName}</>
}
